import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(({

}))

export default ({data}) => {
  const classes = useStyles();

  return <Container>
    <div dangerouslySetInnerHTML={{__html: data.content}}>

    </div>
  </Container>
}